import { Controller } from "@hotwired/stimulus";
import flatpickr from "flatpickr";
import moment from 'moment';

// Connects to data-controller="flatpickr"
export default class extends Controller {
  connect() {
    // set default
    this.set_date_range('Bank Debit - Stripe')
  }

  datescope(event) {
    this.set_date_range(event.currentTarget.value)
  }

  set_date_range(pmode) {
    var jfDate = moment();
    var fiDate = moment().add(1, 'days');

    if (pmode === 'Bank Debit - Stripe') {
      // if jfDate is a weekend, set it to the next working day
      if (jfDate.day() === 6) { // saturday, user is on friday
        jfDate = moment().add(3, 'days');
        fiDate = moment().add(4, 'days');
      } else if (jfDate.day() === 0) { // sunday, user is on saturday
        jfDate = moment().add(2, 'days');
        fiDate = moment().add(3, 'days');
      }

      if (fiDate.day() === 6) { // saturday, user is on friday
        fiDate = moment().add(3, 'days');
      } else if (jfDate.day() === 0) { // sunday, user is on saturday
        fiDate = moment().add(2, 'days');
      }
    }

    flatpickr(".fp_jf",
      {
        enableTime: false,
        dateFormat: "d/m/Y",
        defaultDate: jfDate.toDate(),
        minDate: jfDate.toDate(),
        disable: [
          function(date) {
            if (pmode === 'Bank Debit - Stripe') {
              return (date.getDay() === 0 || date.getDay() === 6);
            }
          }
        ],
        locale: {
          firstDayOfWeek: 1 // start week on Monday
        }
      }
    );

    flatpickr(".fp_fi",
      {
        enableTime: false,
        dateFormat: "d/m/Y",
        defaultDate: fiDate.toDate(),
        minDate: fiDate.toDate(),
        disable:  [
          function(date) {
            if (pmode === 'Bank Debit - Stripe') {
              return (date.getDay() === 0 || date.getDay() === 6);
            }
          }
        ],
        locale: {
          firstDayOfWeek: 1 // start week on Monday
        }
      }
    );
  }
}
